export default __webpack_public_path__ + "images/f2f962ac2e2bfa3b6c2c8c3f349373ad-americana_music.webp";